export default `float j = 0.5;
    for(p.xz=mod(p.xz,6.)-3.;++j<9.;p=3.*p-.9)
      p.xz=abs(p.xz),
      p.z>p.x?p=p.zyx:p,
      p.y>p.z?p=p.xzy:p,
      p.z--,
      p.x-=++p.y*.5;
    return min(.2,p.x/4e3-.2);
  }`